"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvIndicator = void 0;
const react_1 = require("react");
function EnvIndicator({ api_platform }) {
    (0, react_1.useEffect)(() => {
        const isLocalHost = window.location.hostname === 'local.ignif.ai';
        let title_prefix = api_platform.includes('ppnew') ? '🛠 ' : '';
        title_prefix = isLocalHost ? '🚧 ' + title_prefix : title_prefix;
        document.title = title_prefix + document.title;
    }, []);
    return null;
}
exports.EnvIndicator = EnvIndicator;
//# sourceMappingURL=env_indicator.js.map